import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { faAlignJustify } from "@fortawesome/free-solid-svg-icons";
import SelectTextField from "../../../components/SelectTextField";
import ProposicaoService from "../../../services/ProposicaoService";
import TabelasService from "../../../services/TabelasService";
import { IProposicao } from "../../../models/Proposicao.Model";
import { usePallet } from "../../../contexts/PalletContext";
import useStyles from "../../../components/layout/Styles";
import { IFilterData } from "../../../components/filter/ListFilter";
import SelectTextFieldA from "../../../components/SelectTextFieldA";
import InsightService from "../../../services/InsightService";
import { format } from "date-fns";

export function AccordionContentKey34(props: {
  proposicao?: IProposicao;
  dtIni?: Date,
  dtFin?: Date,
  esfera?: string
  onChange?: () => void;
}) {
  const { pallet } = usePallet();
  const classes = useStyles();
  // const [tempoMedio, setTempoMedio] = React.useState<number>(0);
  const [tempoMedioG, setTempoMedioG] = React.useState<number>(0);
  const [tempoMedioT, setTempoMedioT] = React.useState<number>(0);
  const [tempoMedioS, setTempoMedioS] = React.useState<number>(0);
  const [tempoMedioTop, setTempoMedioTop] = React.useState<number>(0);
  const [casa, setCasa] = React.useState<string>("");
  // const [tema, setTema] = React.useState<string>(undefined);
  const [grupo, setGrupo] = React.useState<string>("");
  const [grupoItens, setGrupoItens] = React.useState([]);
  const [tema, setTema] = React.useState<string>("");
  const [temaItens, setTemaItens] = React.useState([]);
  const [subtema, setSubtema] = React.useState<string>("");
  const [subTemaItens, setSubTemaItens] = React.useState([]);
  const [topico, setTopico] = React.useState<string>("");
  const [topicoItens, setTopicoItens] = React.useState([]);

  const [grupoLabel, setGrupoLabel] = React.useState<string>();
  const [temaLabel, setTemaLabel] = React.useState<string>();
  const [subtemaLabel, setSubtemaLabel] = React.useState<string>();
  const [topicoLabel, setTopicoLabel] = React.useState<string>();

  const [casaItens, setCasaFederalItens] = React.useState<Array<IFilterData>>([
    { key: "0", label: "Selecione ", value: "" },
    { key: "1", label: "Senado Federal", value: "SF" },
    { key: "2", label: "Câmara dos Deputados", value: "CD" },
    // { key: "3", label: "Congresso Nacional", value: "CN" },
  ]);

  const getItens = (
    data: { id: number; descricao: string }[]
  ): { value: string; label: string }[] => {
    const ret = data?.map((item) => {
      return {
        value: String(item.id),
        label: item.descricao,
      };
    });
    return ret;
  };

  React.useEffect(() => {
    TabelasService.getProposicaoGrupoTemas().then((resII) => {
      const dataII = getItens(resII);
      // setLoading(false)
      setGrupoItens(dataII);
    });
  }, []);

  React.useEffect(() => {
    if (grupo) {
      TabelasService.getProposicaoTemasByGrupo(Number(grupo)).then((res) => {
        const data = getItens(res);
        setTemaItens(data);
      });
    }
  }, [grupo]);

  React.useEffect(() => {
    if (tema) {
      TabelasService.getProposicaoSubTemasByTema(Number(tema)).then((res) => {
        const data = getItens(res);
        setSubTemaItens(data);
      });
    }
  }, [tema]);


  React.useEffect(() => {
    if (subtema) {
      TabelasService.getProposicaoTopicosBySubtema(Number(subtema)).then((res) => {
        const data = getItens(res);
        setTopicoItens(data);
      });
    }
  }, [subtema]);



  React.useEffect(() => {
    if (grupo) {
      TabelasService.getDescricaoGrupos(Number(grupo)).then((res) => {
        setGrupoLabel("")
        setGrupoLabel(res[0].descricao)
      });
    }
  }, [grupo]);

  React.useEffect(() => {
    if (tema) {
      TabelasService.getDescricaoTemas(Number(tema)).then((res) => {
        setTemaLabel("")
        setTemaLabel(res[0].descricao)
      });
    }
  }, [tema]);

  React.useEffect(() => {
    if (subtema) {
      TabelasService.getDescricaoSubtemas(Number(subtema)).then((res) => {
        setSubtemaLabel("")
        setSubtemaLabel(res[0].descricao)
      });
    }
  }, [subtema]);

  React.useEffect(() => {
    if (topico) {
      TabelasService.getDescricaoSubtemas(Number(topico)).then((res) => {
        if (res) setTopicoLabel(res[0].descricao)
      });
    }
  }, [topico]);


  const onChangeGrupo = (
    event?: React.ChangeEvent<HTMLInputElement>,
    id?: string
  ) => {
    if (id) {
      setGrupo(event.target.value);
      setTema("");
      setSubtema("");
      setTopico("");
      // setListaTemas([])
      // setListaSubtemas([])
    }
  };

  const handleCasaN = (casa: string) => {
    switch (casa) {
      case "SF":
        return 1;
      case "CD":
        return 2;
      case "CN":
        return 3;
      default:
        return -99;
    }
  };

  const onChangeTema = (
    event?: React.ChangeEvent<HTMLInputElement>,
    id?: string
  ) => {
    if (id) {
      setTema(event.target.value);
      setSubtema("");
      setTopico("");
      // setListaSubtemas([])
    }
  };

  const onChangeSubtema = (
    event?: React.ChangeEvent<HTMLInputElement>,
    id?: string
  ) => {
    if (id) {
      setSubtema(event.target.value);
      setTopico("");
    }
  };


  const onChangeTopico = (
    event?: React.ChangeEvent<HTMLInputElement>,
    id?: string
  ) => {
    if (id) {
      setTopico(event.target.value);
    }
  };

  const handleCasa = (
    event?: React.ChangeEvent<HTMLInputElement>,
    id?: number
  ) => {
    setCasa(event.target.value);
    handleCasaLabel(casa);
    setGrupo("");
    setTema("");
    setSubtema("");
    setTopico("");
  };

  const handleTema = (
    event?: React.ChangeEvent<HTMLInputElement>,
    id?: number
  ) => {
    setTema(event.target.value);
    handleCasaLabel(casa);
  };

  const handleCasaLabel = (casa: string) => {
    switch (casa) {
      case "SF":
        return "Senado Federal";
      case "CD":
        return "Câmara dos Deputados";
      case "CN":
        return "Congresso Nacional";
      default:
        return "Todas";
    }
  };

  React.useEffect(() => {
    if (grupo) {
      if (String(format(new Date(props.dtIni), "yyyy")).slice(0, 1) !== '0' && String(format(new Date(props.dtFin), "yyyy")).slice(0, 1) !== '0') {
        InsightService.GetKey34Grupo(
          format(new Date(props.dtIni), "yyyy-MM-dd"),
          format(new Date(props.dtFin), "yyyy-MM-dd 23:59:00.000"), casa, Number(grupo),
        ).then((res) => {
          if (res) {
            setTempoMedioG(res.data.total)
          }
        });
      }
    }
    if (tema) {
      if (tema) {
        if (String(format(new Date(props.dtIni), "yyyy")).slice(0, 1) !== '0' && String(format(new Date(props.dtFin), "yyyy")).slice(0, 1) !== '0') {
          InsightService.GetKey34Tema(
            format(new Date(props.dtIni), "yyyy-MM-dd"),
            format(new Date(props.dtFin), "yyyy-MM-dd 23:59:00.000"), casa, Number(tema),
          ).then((res) => {
            if (res) {
              setTempoMedioT(res.data.total)
            }
          });
        }
      }
      if (subtema) {
        if (String(format(new Date(props.dtIni), "yyyy")).slice(0, 1) !== '0' && String(format(new Date(props.dtFin), "yyyy")).slice(0, 1) !== '0') {
          InsightService.GetKey34Subtema(
            format(new Date(props.dtIni), "yyyy-MM-dd"),
            format(new Date(props.dtFin), "yyyy-MM-dd 23:59:00.000"), casa, Number(subtema),
          ).then((res) => {
            if (res) {
              setTempoMedioS(res.data.total)

            }
          });
        }
      }
      if (topico) {
        if (String(format(new Date(props.dtIni), "yyyy")).slice(0, 1) !== '0' && String(format(new Date(props.dtFin), "yyyy")).slice(0, 1) !== '0') {
          InsightService.GetKey34Subtema(
            format(new Date(props.dtIni), "yyyy-MM-dd"),
            format(new Date(props.dtFin), "yyyy-MM-dd 23:59:00.000"), casa, Number(topico),
          ).then((res) => {
            if (res) {
              setTempoMedioTop(res.data.total)

            }
          });
        }
      }
    }
  }, [casa, grupo, tema, subtema,topico, props.dtIni, props.dtFin]);

  return (
    <Grid>
      <Grid
        container
        style={{
          padding: "40px 0px 10px 0px",
          justifyContent: "space-around",
          placeContent: "center",

        }}
      >
        <Grid item md={5} xs={12} lg={5} style={{ padding: `${isMobile ? "0px 30px 20px 30px" : "0px"}` }}>
          <SelectTextFieldA
            name={"casa-federal"}
            value={casa}
            onChange={handleCasa}
            options={casaItens}
            label={"CASA LEGISLATIVA"}
            id={"casa-federal"}
            focused={true}
            placeholder={"Selecione"}
          />
        </Grid>
        {casa ?
          <Grid container
            style={{
              padding: `${isMobile ? "0px 30px 0px 30px" : "30px 30px 20px 10px"}`,
              placeContent: "center"
            }} >
            <Grid
              md={4}
              xs={12}
              lg={4}
            >
              <SelectTextFieldA
                id={"grupo"}
                label="GRUPO"
                options={grupoItens}
                value={grupo}
                onChange={onChangeGrupo}
                focused={true}
                placeholder={"Selecione"}
              />
            </Grid>
          </Grid>
          : null}
      </Grid>
      <Grid container
        style={{ placeContent: "center" }}
      >
        {grupo ?
          <Grid
            container
            xs={12}
            style={{ padding: `${isMobile ? "20px 30px 20px 30px" : "0px 30px 0px 30px"}` }}
          >
            <Grid
              container
              item
              direction={"row"}
              style={{
                padding: "20px",
                color: `${pallet.textColorTertiary}`,
                fontFamily: `${pallet.general.fontFamily}`,
                fontSize: `${pallet.general.size14}`,
                placeContent: "center",
                backgroundColor: "#F9F5FE",
                borderRadius: "5px"
              }}
            >

              <Grid style={{ fontWeight: pallet.general.weight_600 }}>
                TEMPO MÉDIO DE TRAMITAÇÃO DAS PROPOSIÇÕES - {grupoLabel} :
              </Grid>&nbsp;&nbsp;
              <Grid>{tempoMedioG} dias</Grid>
            </Grid>
          </Grid> : null
        }
        {
          <>
            {grupo ?
              <Grid
                style={{
                  padding: `${isMobile ? "0px 30px 0px 30px" : "30px 30px 20px 10px"}`,
                }}
                item
                md={4}
                xs={12}
                lg={4}
              >
                <SelectTextFieldA
                  id={"tema"}
                  name="tema-select"
                  label="TEMA"
                  options={temaItens}
                  value={tema}
                  onChange={onChangeTema}
                  focused={true}
                  placeholder={"Selecione"}
                />
              </Grid>
              : null
            }
          </>
        }
        {
          tema ?
            <Grid
              container
              xs={12}
              style={{ padding: `${isMobile ? "20px 30px 20px 30px" : "0px 30px 0px 30px"}` }}
            >
              <Grid
                container
                item
                direction={"row"}
                style={{
                  // marginRight: "30px",
                  // marginLeft: "30px",
                  padding: "20px",
                  color: `${pallet.textColorTertiary}`,
                  fontFamily: `${pallet.general.fontFamily}`,
                  fontSize: `${pallet.general.size14}`,
                  placeContent: "center",
                  backgroundColor: "#F9F5FE",
                  borderRadius: "5px"
                }}
              >

                <Grid style={{ fontWeight: pallet.general.weight_600 }}>
                  TEMPO MÉDIO DE TRAMITAÇÃO DAS PROPOSIÇÕES DO TEMA -  {temaLabel} :
                </Grid>&nbsp;&nbsp;
                <Grid>{tempoMedioT} dias</Grid>
              </Grid>
            </Grid> : null
        }
        {
          <>
            {tema ?
              <Grid
                style={{ padding: `${isMobile ? "0px 30px 0px 30px" : "30px 30px 20px 10px"}` }}
                item
                md={4}
                xs={12}
                lg={4}
              >
                <SelectTextFieldA
                  id={"subtema"}
                  label="SUBTEMA"
                  options={subTemaItens}
                  value={subtema}
                  onChange={onChangeSubtema}
                  focused={true}
                  placeholder={"Selecione"}
                />
                
              </Grid>
              
              : null
            }
          </>
        }
                {
          subtema ?
            <Grid
              container
              xs={12}
              style={{ padding: `${isMobile ? "20px 30px 20px 30px" : "0px 30px 0px 30px"}` }}
            >
              <Grid
                container
                item
                direction={"row"}
                style={{
                  // marginRight: "30px",
                  // marginLeft: "30px",
                  padding: "20px",
                  color: `${pallet.textColorTertiary}`,
                  fontFamily: `${pallet.general.fontFamily}`,
                  fontSize: `${pallet.general.size14}`,
                  placeContent: "center",
                  backgroundColor: "#F9F5FE",
                  borderRadius: "5px"
                }}
              >

                <Grid style={{ fontWeight: pallet.general.weight_600 }}>
                  TEMPO MÉDIO DE TRAMITAÇÃO DAS PROPOSIÇÕES DO SUBTEMA -  {subtemaLabel} :
                </Grid>&nbsp;&nbsp;
                <Grid>{tempoMedioS} dias</Grid>
              </Grid>
            </Grid> : null
        }

{
          <>
            {subtema ?
              <Grid
                style={{ padding: `${isMobile ? "0px 30px 0px 30px" : "30px 30px 20px 10px"}` }}
                item
                md={4}
                xs={12}
                lg={4}
              >
                <SelectTextFieldA
                  id={"topico"}
                  label="TOPICO"
                  options={topicoItens}
                  value={topico}
                  onChange={onChangeTopico}
                  focused={true}
                  placeholder={"Selecione"}
                />
              </Grid>
              : null
            }
          </>
        }


        {
          topico ?
            <Grid
              container
              xs={12}
              style={{ padding: `${isMobile ? "20px 30px 20px 30px" : "0px 30px 20px 30px"}` }}
            >
              <Grid
                container
                item
                direction={"row"}
                style={{
                  // marginRight: "30px",
                  // marginLeft: "30px",
                  padding: "20px",
                  color: `${pallet.textColorTertiary}`,
                  fontFamily: `${pallet.general.fontFamily}`,
                  fontSize: `${pallet.general.size14}`,
                  placeContent: "center",
                  backgroundColor: "#F9F5FE",
                  borderRadius: "5px"
                }}
              >

                <Grid style={{ fontWeight: pallet.general.weight_600 }}>
                  TEMPO MÉDIO DE TRAMITAÇÃO DAS PROPOSIÇÕES DO TÓPICO - {topicoLabel} :
                </Grid>&nbsp;&nbsp;
                <Grid>{tempoMedioTop} dias</Grid>
              </Grid>
            </Grid> : null
        }

      </Grid>
    </Grid>
  );
}

export default AccordionContentKey34;
